import { fetchData } from '../containers/GamedayAppContainer';
import { routes as finalRoutes } from '@gameday/components/Final/containers/FinalDataContainer';
import { routes as liveRoutes } from '@gameday/components/Live/containers/LiveDataContainer';
import { routes as previewRoutes } from '@gameday/components/Preview/containers/PreviewDataContainer';
import routesConfig from './routesConfig';

const dataRouterConfig = {
    routes: [
        {
            exact: false,
            path: '/',
            routes: [
                ...finalRoutes,
                ...liveRoutes,
                ...previewRoutes
            ],
            fetchData: (state) => fetchData(state)
        }
    ]
};


export default dataRouterConfig;
export { routesConfig };
